/**
 * Delay `func` until `wait` ms after the last call.
 *
 * @param {Function} func
 * @param {number} wait Milliseconds.
 * @returns {Function}
 */
export function debounce(func, wait) {
  let to = null;
  return (...args) => {
    if (to) {
      clearTimeout(to);
    }

    to = setTimeout(() => {
      to = null;
      func(...args);
    }, wait);
  };
}
